import { IBox } from '@/typing/api/box.interface';
import { Trip } from '@/typing/api/tripNew.class';
import dayjs from 'dayjs';
import $dayjs from '../dayjs';

export function getTripTimes(trip: Trip, addDelayTimes = false): any {
    const format = 'YYYY-MM-DD HH:mm';
    const temp: any = {
        startTime: $dayjs(
            `${trip.startTimeDate} ${trip.startTime}`,
            format,
            true
        ),
        startTimeDredging: $dayjs(
            `${trip.startTimeDredgingDate} ${trip.startTimeDredging}`,
            format,
            true
        ),
        endTimeDredging: $dayjs(
            `${trip.endTimeDredgingDate} ${trip.endTimeDredging}`,
            format,
            true
        ),
        startTimeDumping: $dayjs(
            `${trip.startTimeDumpingDate} ${trip.startTimeDumping}`,
            format,
            true
        ),
        endTimeDumping: $dayjs(
            `${trip.endTimeDumpingDate} ${trip.endTimeDumping}`,
            format,
            true
        ),
    };

    if (addDelayTimes) {
        temp['startTimeDelay'] = $dayjs(
            `${trip.startTimeDelayDate} ${trip.startTimeDelay}`,
            format,
            true
        );
        temp['endTimeDelay'] = $dayjs(
            `${trip.endTimeDelayDate} ${trip.endTimeDelay}`,
            format,
            true
        );
    }

    const newObj: any = {};

    Object.keys(temp).forEach((key: string) => {
        if (temp[key] && temp[key].isValid()) {
            newObj[key] = temp[key];
        }
    });

    return newObj;
}

export function checkTripTimes(trip: Trip, dumpingIsRequired: boolean): any {
    let hasError = false;
    const erroredDates: any = { first: null, last: null };
    const dates = getTripTimes(trip);
    const keys = Object.keys(dates);

    if (dates.startTime) {
        const tripDate = $dayjs(trip.date, 'DD/MM/YYYY', true);
        if (tripDate.isValid()) {
            if (!(dates.startTime as dayjs.Dayjs).isSame(tripDate, 'day')) {
                return {
                    hasError: true,
                    message: 'Datum komt niet overeen met datum (Start Cyclus)',
                };
            }
        }
    }

    hasError = keys.some((key: string, i: number) => {
        if (i === 0) return false;
        const currentDate: dayjs.Dayjs = dates[key];
        const previousDate: dayjs.Dayjs = dates[keys[i - 1]];

        if (
            currentDate.isBefore(previousDate, 'minute') ||
            currentDate.isBefore(previousDate, 'day')
        ) {
            erroredDates.first = previousDate;
            erroredDates.last = currentDate;
            return true;
        }
    });

    if (hasError) {
        const format = 'DD/MM/YYYY HH:mm';
        return {
            hasError: true,
            message: `Deze reis is niet in chronologische volgorde ingevuld. (${erroredDates.first.format(
                format
            )} & ${erroredDates.last.format(format)})`,
        };
    } else {
        return checkDelayTimes(trip, dates, dumpingIsRequired);
    }
}

export const boxValidator: any = (
    itemValue: any,
    selectOptions: IBox[],
    trip: Trip
): any => {
    const hasValue = selectOptions.some(
        (val: IBox) =>
            val.boxName.toLowerCase() === (trip?.boxName ?? '').toLowerCase() &&
            val.boxNumber.toLowerCase() === (trip.boxNumber ?? '').toLowerCase()
    );

    return {
        hasError: hasValue === false,
        message: 'Is niet bekend.',
    };
};

export function checkDelayTimes(
    trip: Trip,
    dates: any,
    dumpingIsRequired: boolean
): any {
    if (!trip.startTimeDelay || !trip.endTimeDelay) return { hasError: false };
    const startDelay = $dayjs(
        `${trip.startTimeDelayDate} ${trip.startTimeDelay}`,
        'YYYY-MM-DD HH:mm'
    );

    const endOfTripProperty =
        dumpingIsRequired || trip.endTimeDumping
            ? 'endTimeDumping'
            : 'endTimeDredging';

    if (!dates.startTime || !dates[endOfTripProperty]) {
        return { hasError: false };
    }

    const startTime = dates.startTime;

    if (startDelay < startTime) {
        return {
            hasError: true,
            message: 'Verlet starttijd is vroeger dan de start van de reis',
        };
    }

    return {
        hasError: false,
    };
}
